import { render, staticRenderFns } from "./ItemsCreateForm.vue?vue&type=template&id=683ee25a&"
import script from "./ItemsCreateForm.vue?vue&type=script&lang=js&"
export * from "./ItemsCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports